import { useEffect, useState, useContext, useRef, useLayoutEffect } from "react";
import { useParams } from "react-router";

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import CategoryProduct from "../preinvoice/category-product";
import { getEndpoint } from "../helper";

export default function Brand({ }) {
    const { id } = useParams();

    const [data, setData] = useState({ slides: [] });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { setPageTitle, setBrandId } = useContext(LayoutContext);

    const slickRef = useRef(null);
    const scrollY = useRef(0);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/brand/GetImageSlider?brandId=${id}`), { signal });
                const json = await response.json();
                setData({ slides: json.data });

                setPageTitle(json.data[0].brandTitle);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        setBrandId(id);

        return () => controller.abort();
    }, []);

    useEffect(() => {
        if (!data || !data.slides) return;

        $(slickRef.current).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            rtl: true,
            infinite: false
        });
    }, [data]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div>
            <div dir='rtl' className=''>
                <div className='js__slick' ref={slickRef}>
                    {data.slides.map((x, i) => (
                        <div className='d-b' key={i}>
                            <img src={getEndpoint(`/uploads/shop/brand-file/${x.fileName}`)} />
                        </div>
                    ))}
                </div>
            </div>

            <CategoryProduct brandId={id} />
        </div>
    );
}